import './styles.scss';
import { useState } from 'react';
import { amenitiesMapData } from './consts';
import { Filter } from './components/Filter';
import { MapLayout } from './components/MapLayout';
import { AmenityModal } from './components/Modal';
import { SettingControl } from 'components/SettingControl';
import { usePageTracking } from 'hooks/usePageTracking';

const SoDoTienIchPage = (props) => {
  usePageTracking('amenity-layout');
  const [floor, setFloor] = useState('t1');
  const [hoveredAmenity, setHoveredAmenity] = useState(null);
  const [clickedAmenity, setClickedAmenity] = useState(null);

  const currentFloor = amenitiesMapData[floor];

  return (
    <div className="so-do-tien-ich-page">
      <Filter
        currentFloor={currentFloor}
        onChangeCurrent={setFloor}
        onHover={setHoveredAmenity}
        onClick={setClickedAmenity}
        hoveredAmenity={hoveredAmenity}
      />
      <MapLayout
        currentFloor={currentFloor}
        onHover={setHoveredAmenity}
        onClick={setClickedAmenity}
        hoveredAmenity={hoveredAmenity}
      />
      <AmenityModal
        open={!!clickedAmenity}
        clickedAmenity={clickedAmenity}
        currentFloor={currentFloor}
        onClose={() => setClickedAmenity(null)}
      />
      <SettingControl />
    </div>
  );
};

export default SoDoTienIchPage;
